const STORAGE_KEY = 'payments_recent_searches';
const MAX_ITEMS = 5;

export function readRecentSearches(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string').slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}

export function saveRecentSearch(raw: string): void {
  if (typeof window === 'undefined') return;
  try {
    const trimmed = raw.trim();
    if (!trimmed) return;
    const prev = readRecentSearches();
    const deduped = [trimmed, ...prev.filter((x) => x !== trimmed)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(deduped));
  } catch {
    // private mode / quota
  }
}

export function removeRecentSearch(raw: string): void {
  if (typeof window === 'undefined') return;
  try {
    const prev = readRecentSearches();
    const next = prev.filter((x) => x !== raw);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // private mode / quota
  }
}
